import { faAngleDown as lightAngleDown } from "@jewlr/pro-light-svg-icons/faAngleDown"
import { faAngleUp as lightAngleUp } from "@jewlr/pro-light-svg-icons/faAngleUp"
import PropTypes from "prop-types"
import { useState } from "react"

import Button from "components/ui/button"
import Expand from "components/ui/expand"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { cn } from "styles/utils"

import FilterCategories from "./filter-categories"
import withFilters from "./hoc/with-filters"

const InternalFilterPanel = ({ filter, isMobile }) => {
  const [openCategories, setOpenCategories] = useState(() =>
    // If any categories are checked, open the panel
    filter.categories.some((cat) => cat.is_active_filter)
  )

  return (
    <div>
      <div
        className={cn(
          "desktop:border-b-0",
          openCategories ? "border-b-0" : "border-grey-10 border-b"
        )}
      >
        <h2 className="py-8">
          <Button
            aria-controls={`collection-filter-content-${filter.name}`}
            aria-expanded={openCategories}
            className="text-18 w-full justify-between py-8 font-bold text-black"
            data-cy={`collection-filter-panel-${filter.name
              .replace(/\s+/g, "-")
              .toLowerCase()}-${isMobile ? "mobile" : "desktop"}`}
            id={`collection-filter-heading-${filter.name}`}
            onClick={() => setOpenCategories(!openCategories)}
          >
            <p>{filter.name}</p>
            <FontAwesomeIcon
              icon={openCategories ? lightAngleUp : lightAngleDown}
            />
          </Button>
        </h2>
      </div>
      <Expand
        aria-labelledby={`collection-filter-heading-${filter.name}`}
        className="desktop:border-b-0 border-grey-10 border-b"
        id={`collection-filter-content-${filter.name}`}
        show={openCategories}
      >
        <FilterCategories filter={filter} isMobile={isMobile} />
      </Expand>
    </div>
  )
}

InternalFilterPanel.propTypes = {
  filter: PropTypes.object,
  isMobile: PropTypes.bool,
}

const FilterPanel = withFilters(InternalFilterPanel)

export default FilterPanel
